import { useQuery } from '@apollo/client';
import { useTheme } from 'styled-components';
import {
  Accordion,
  AccordionBody,
  AccordionItem,
  AccordionTrigger,
} from '../components/Accordion';
import Avatar from '../components/Avatar';
import { SectionItem, SectionName } from '../components/Chrome';
import Grid from '../components/Grid';
import Loader from '../components/Loader';
import { Modal, ModalExit, ModalPart } from '../components/Modal';
import Text from '../components/Text';
import Tooltip from '../components/Tooltip';
import { COMMENT_VERSIONS } from '../utilities/queries';
import { getDate } from '../utilities/getDate';
import { getRelativeTime } from '../utilities/getRelativeTime';
import { markdown } from '../utilities/markdown';

const VersionsModal = ({ commentId, onClose }) => {
  const theme = useTheme();
  const { loading, data } = useQuery(COMMENT_VERSIONS, {
    variables: { id: commentId },
  });

  const close = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal onClose={() => close()} showScrollbar>
      {loading || !data?.comment?.versions ? (
        <ModalPart>
          <Loader />
        </ModalPart>
      ) : (
        <>
          <ModalExit onClick={() => close()} dontCloseOnClick />
          <SectionName isPadded>Versions</SectionName>
          {data?.comment?.versions.length !== 0 ? (
            <Accordion>
              {data.comment.versions.map((version) => (
                <AccordionItem key={version.publicId}>
                  <AccordionTrigger isPadded>
                    <Grid gap={theme.space[1]}>
                      <Text>Version {version.publicId}</Text>
                      <Tooltip text={getDate(version.createdAt)}>
                        <Text>{getRelativeTime(version.createdAt)}</Text>
                      </Tooltip>
                      <Tooltip text={version.author.name}>
                        <Avatar isSmall src={version.author.avatarUrl} />
                      </Tooltip>
                    </Grid>
                  </AccordionTrigger>
                  <AccordionBody isPadded>
                    {markdown.render(version.body)}
                  </AccordionBody>
                </AccordionItem>
              ))}
            </Accordion>
          ) : (
            <SectionItem
              style={{ padding: `${theme.space[2]} ${theme.space[6]}` }}
            >
              No versions found.
            </SectionItem>
          )}
        </>
      )}
    </Modal>
  );
};

export default VersionsModal;
